module.exports = __webpack_public_path__ + "static/media/logo-white.31de2d71.svg";